export enum authActions {
    SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN',
    SET_USER_TOKENS = 'SET_USER_TOKENS',
    SET_RECENT_AUTHS = 'SET_RECENT_AUTHS',
    SET_AUTH_ERROR = 'SET_AUTH_ERROR',
    LOG_OUT = 'LOG_OUT',
    SET_AUTH_USER = 'SET_AUTH_USER',
}
